// Packages and components
import React, { useState } from 'react';

// Helpers and utilities
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import { generateUniqueKey } from '@theme-utils/data';

// Styles
import {
  StyledInputPhoneNumber,
  StyledFormField,
} from './SHDInputPhoneNumber.styles';

// Types
import type { SHDInputPhoneNumberProps } from './SHDInputPhoneNumber.d';

// Constants
const fieldId = generateUniqueKey('phone-number');

const SHDInputPhoneNumber: React.FC<SHDInputPhoneNumberProps> = ({
  className = 'phone-number-input',
  disabled = false,
  error = null,
  label = 'Phone number',
  isReadOnly = false,
  isBorderless = false,
  onChange,
  onFocusOut,
  onPossiblePhoneNumber,
}) => {
  // States
  const [phoneNumberValue, setPhoneNumberValue] = useState<string>('');

  // Handlers
  const onInputChange = (val: string = '') => {
    setPhoneNumberValue(val);
    if (isPossiblePhoneNumber(val)) {
      onPossiblePhoneNumber && onPossiblePhoneNumber(true);
    } else {
      onPossiblePhoneNumber && onPossiblePhoneNumber(false);
    }
    onChange(val);
  };

  return (
    <div className={`${className} full-width`}>
      <StyledFormField
        label={isBorderless ? '' : label}
        a11yTitle="Please enter your phone number to sign in."
        htmlFor={`${fieldId}`}
        className={`${className}__label relative${isBorderless ? ' is-borderless' : ''}${error ? ' has-error' : ''}`}
        error={error?.message}
      >
        <StyledInputPhoneNumber
          a11ytitle="Phone number"
          className={`${className}__input${error ? ' has-error' : ''}`}
          defaultCountry="US"
          placeholder={isBorderless ? label : ''}
          disabled={disabled}
          id={`${fieldId}`}
          key={`${fieldId}`}
          onChange={onInputChange}
          onBlur={() => {
            onFocusOut && onFocusOut();
          }}
          readOnly={isReadOnly}
          value={phoneNumberValue}
        />
      </StyledFormField>
    </div>
  );
};

export default SHDInputPhoneNumber;
